export function startCosmicEffect({ imgPanelEl }) {
  if (!imgPanelEl) return () => {};

  const canvas = imgPanelEl.querySelector('canvas.cosmic-canvas[data-kind="cosmic-canvas"]');
  if (!canvas) return () => {};

  const ctx = canvas.getContext('2d');
  if (!ctx) return () => {};

  const resize = () => {
    const w = imgPanelEl.offsetWidth || 0;
    const h = imgPanelEl.offsetHeight || 0;
    canvas.width = Math.max(1, w);
    canvas.height = Math.max(1, h);
  };

  resize();

  const stars = [];
  const starCount = 70;
  for (let i = 0; i < starCount; i++) {
    stars.push({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      r: Math.random() * 1.8 + 0.2,
      opacity: Math.random() * 0.8 + 0.2,
      twinkle: Math.random() * 0.22 + 0.06
    });
  }

  const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(resize) : null;
  if (observer) observer.observe(imgPanelEl);

  let rafId = 0;
  let lastTs = 0;

  const draw = (ts) => {
    rafId = requestAnimationFrame(draw);
    if (!lastTs) lastTs = ts;
    const dt = ts - lastTs;
    if (dt < 33) return; // ~30fps cap
    lastTs = ts;

    const w = canvas.width;
    const h = canvas.height;
    if (w <= 1 || h <= 1) return;

    ctx.clearRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'source-over';
    ctx.shadowColor = 'rgba(183, 148, 246, 0.45)';
    ctx.shadowBlur = 6;

    for (let i = 0; i < stars.length; i++) {
      const s = stars[i];
      s.opacity += (Math.random() - 0.5) * s.twinkle;
      s.opacity = Math.max(0.15, Math.min(1, s.opacity));

      ctx.fillStyle = `rgba(183, 148, 246, ${s.opacity})`;
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.shadowBlur = 0;
  };

  rafId = requestAnimationFrame(draw);
  window.addEventListener('resize', resize);

  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    if (observer) observer.disconnect();
    window.removeEventListener('resize', resize);
  };
}
